import React from "react";
import type { AssistantMediaPart } from "../../../chat/types";
import { AnimatedCard } from "../../Common/AnimatedCard";

export function MediaVideoCard({ part }: { part: AssistantMediaPart }) {
  return (
    <AnimatedCard variant="sm" sx={{ p: 1, my: 1, maxWidth: 640 }}>
      <video src={part.url} controls style={{ width: "100%", borderRadius: 12, display: "block" }} aria-label={part.alt} />
    </AnimatedCard>
  );
}
